import { FC, useEffect, useState } from "react";
import { backend } from "../../../../Backend";
import { useSnackbar } from "notistack";
import LoadingPattern from "../../../../components/LoadingPattern";
import Embed from "components/Looker/Embed";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";

export interface LookerEmbedView {
  lensId: number;
  name: string;
  url: string;
}

const LookerEmbedView: FC<LookerEmbedView> = (props) => {
  const { url } = props;

  const { searchParams } = useSearchParamsWithUpdate();

  const caseId = searchParams.get("caseId") || undefined;

  const [embedSsoUrl, setEmbedSsoUrl] = useState<string>();
  const [loading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setLoading(true);
    backend
      .getLookerEmbedUrl(url, caseId ? parseInt(caseId) : undefined)
      .then(({ embedUrl }) => {
        setEmbedSsoUrl(embedUrl);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error loading Looker report", err);
        enqueueSnackbar("Error loading Report", {
          variant: "error",
        });
      });
  }, [url]);

  return !loading && embedSsoUrl ? <Embed url={embedSsoUrl} /> : <LoadingPattern centered />;
};

export default LookerEmbedView;
